import React, { useState } from 'react';
import './Header.css';
import Sidebar from './Sidebar';
import NavLinks from './NavLinks';

const Header = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <nav className="header">
        <div className="header-container">
          <div className="header-content">
            <div className="mobile-menu-button">
              <button
                aria-label="Mobile menu"
                className="hamburger"
                onClick={toggleSidebar}
              >
                <svg className="hamburger-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                </svg>
              </button>
            </div>
            <div className="logo">
              <a  href="home" aria-label="Go to Sinch home page">
                <img
                  src="https://www.sinch.com/wp-content/themes/simpletexting-theme-blank/assets/images/logo-sinch.svg"
                  alt="Sinch Logo"
                  className="logo-img"
                />
              </a>
            </div>
            <div className="nav-menu">
              <NavLinks />
            </div>
            <div className="cta-buttons">
              <a href="home" className="cta-button cta-filled">
                Talk to an expert
              </a>
              <a href="home" className="cta-button cta-outlined">
                Try for free
              </a>
            </div>
          </div>
        </div>
      </nav>
      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
    </>
  );
};

export default Header;